import IztExhibitorCard from './src/izt-exhibitor-card.vue'

IztExhibitorCard.install = Vue => {
  Vue.component(IztExhibitorCard.name, IztExhibitorCard)
}

export default IztExhibitorCard
